import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

import en from "./locales/en";
import ar from "./locales/ar";
import type { Language } from "@/shared/types";

const resources = {
  en: { translation: en },
  ar: { translation: ar },
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["en", "ar"],
    debug: import.meta.env.DEV,

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "cost_control_language",
    },

    react: {
      useSuspense: true,
    },
  });

// Function to change language and direction
export const changeLanguage = async (lng: Language) => {
  await i18n.changeLanguage(lng);
  const direction = lng === "ar" ? "rtl" : "ltr";
  document.documentElement.dir = direction;
  document.documentElement.lang = lng;
};

export default i18n;
